module.exports = __webpack_public_path__ + "static/russian-test-01-ced9b3fda80c02906efce4bd82a9160a.png";